import Login from '../components/Login/Login';

// Rutas cargadas de forma diferida (code-splitting): cada una genera su propio
// chunk que solo se descarga cuando el usuario navega a esa sección, en vez de
// venir incluido en el bundle inicial (login).
const MyAccount = () => import(/* webpackChunkName: "myaccount" */ '../components/Login/MyAccount.vue');
const http404 = () => import(/* webpackChunkName: "http404" */ '../components/http404');
const MainAsistencia = () => import(/* webpackChunkName: "dashboard" */ '../components/Assists/MainAsistencia');
const uploadDocument = () => import(/* webpackChunkName: "upload-document" */ '../components/DocumentsClient/MainDocument');
const sharedDocument = () => import(/* webpackChunkName: "shared-document" */ '../components/DocumentsClientShared/MainDocument');
const VoucherCase = () => import(/* webpackChunkName: "voucher-case" */ '../components/VoucherCase/dashboard');
const Refunds = () => import(/* webpackChunkName: "refunds" */ '../components/Refunds/dashboard');
const ViewDocuments = () => import(/* webpackChunkName: "refunds" */ '../components/Refunds/ViewDocuments');
const RePricing = () => import(/* webpackChunkName: "re-pricing" */ '../components/RePricing/dashboard');
const Invoice = () => import(/* webpackChunkName: "invoice" */ '../components/invoice/dashboard');
const InvoiceStatement = () => import(/* webpackChunkName: "invoice-statement" */ '../components/InvoiceStatement/Dashboard');
const AssistanceBills = () => import(/* webpackChunkName: "assistance-bills" */ '../components/AssistanceBills/dashboard');
const ReportsClient = () => import(/* webpackChunkName: "reports-client" */ '../components/ReportsClient/dashboard');
const ClientCharts = () => import(/* webpackChunkName: "client-charts" */ '../components/ClientCharts/dashboard');
const DocumentsReport = () => import(/* webpackChunkName: "documents-report" */ '../components/AssistanceFiles/DocumentsReportDashboard');
const Survey = () => import(/* webpackChunkName: "survey" */ '../components/Survey/dashboard');

export default [
    {
        path: '/',
        redirect: '/login'
    },
    {
        name: 'Login',
        path: '/login/:entity?/:entityId?',
        component: Login,
        meta: {
            isPublic: true
        }
    },
    {
        name: 'dashboard',
        path: '/dashboard',
        component: MainAsistencia,
    },
    {
        name: 'documents-report',
        path: '/documents-report',
        component: DocumentsReport,
    },
    {
        name: 'upload_document',
        path: '/upload_document',
        component: uploadDocument,
    },
    {
        name: 'shared_document',
        path: '/shared_document',
        component: sharedDocument,
    },
    {
        name: 'VoucherCase',
        path: '/voucher_case',
        component: VoucherCase,
    },
    {
        name: 'RePricing',
        path: '/re-pricing',
        component: RePricing,
    },
    {
        name: 'Invoice',
        path: '/invoice',
        component: Invoice,
    },
    {
        name: 'InvoiceStatement',
        path: '/invoice_statement',
        component: InvoiceStatement,
    },
    {
        name: 'reports-client',
        path: '/reports-client',
        component: ReportsClient,
    },
    {
        name: 'client-charts',
        path: '/charts/:screen?',
        component: ClientCharts,
    },
    {
        name: 'MyAccount',
        path: '/MyAccount',
        component: MyAccount,
    },
    {
        path: '/:lang/refunds/:code',
        redirect: '/:lang/reimbursement/:code',
    },
    {
        path: '/refunds/:code',
        redirect: '/en/reimbursement/:code',
    },
    {
        path: '/RF/:code',
        redirect: '/en/reimbursement/:code',
    },
    {
        path: '/:lang/RF/:code',
        redirect: '/:lang/reimbursement/:code',
    },
    {
        path: '/reimbursement/:code',
        redirect: '/en/reimbursement/:code',
    },
    {
        name: 'Refunds',
        path: '/:lang/reimbursement/:code',
        component: Refunds,
        meta: {
            isPublic: true
        }
    },
    {
        name: 'ViewDocuments',
        path: '/:lang/reimbursement/:code/view-documents',
        component: ViewDocuments,
        meta: {
            isPublic: true
        }
    },
    {
        name: 'Survey',
        path: '/:lang/survey/:code',
        component: Survey,
        meta: {
            isPublic: true
        }
    },
    {
        path: '/AssistanceBills/:code/:providerId',
        redirect: '/en/AssistanceBills/:code/:providerId',
    },
    {
        name: 'AssistanceBills',
        path: '/:lang/AssistanceBills/:code/:providerId',
        component: AssistanceBills,
        meta: {
            isPublic: true
        }
    },
    {
        path: "**",
        name: "http404",
        component: http404,
        meta: {
            isPublic: true
        }
    }
]
